export enum ContactHistoryType {
  email = "email",
  mobilepush = "mobilepush",
  scenarioupdate = "scenarioupdate",
  calltranscript = "calltranscript",
  updatemanualinfo = "updatemanualinfo",
  qualification = "qualification",
  messagereceived = "messagereceived",
  messagesent = "messagesent",
  datadeletionrequest = "datadeletionrequest",
  contactexist = "contactexist",
  phoneexist = "phoneexist",
  updatebyiainfo = "updatebyiainfo",
  aipaused = "aipaused",
  taskupdated = "taskupdated",
  taskcreated = "taskcreated",
  updatedbyleedflow = "updatedbyleedflow",
  note = "note",
  call = "call",
  receptionist = "receptionist",
  voicemailreceived = "voicemailreceived",
  notificationupdate = "notificationupdate",
  whatsappsent = "whatsappsent",
  whatsappreceived = "whatsappreceived",
  whatsappsummary = "whatsappsummary",
  tagsupdatedbyia = "tagsupdatedbyia",
  confidentialenabled = "confidentialenabled",
  confidentialdisabled = "confidentialdisabled"
}

// Get the history type info
export const contactHistoryTypeAsInfo = (contactHistoryType: string, details: string): string => {
  switch (contactHistoryType) {
    case ContactHistoryType.email:
      return "Notification de prospect <intéressé/en réflexion/inactif>";
    case ContactHistoryType.scenarioupdate:
      return `Modification en scénario ${details || ''}`;
    case ContactHistoryType.qualification:
      return `Qualifié en ${details || ''}`;
    case ContactHistoryType.calltranscript:
    case ContactHistoryType.updatemanualinfo:
    case ContactHistoryType.updatebyiainfo:
    case ContactHistoryType.taskcreated:
    case ContactHistoryType.updatedbyleedflow:
    case ContactHistoryType.note:
    case ContactHistoryType.messagereceived:
    case ContactHistoryType.messagesent:
    case ContactHistoryType.voicemailreceived:
    case ContactHistoryType.whatsappsent:
    case ContactHistoryType.whatsappreceived:
    case ContactHistoryType.whatsappsummary:
    case ContactHistoryType.tagsupdatedbyia:
      return details || '';
    default:
      return details || '';
  }
};

// Get the history type
export const contactHistoryTypeAsString = (contactHistoryType: ContactHistoryType): string => {
  switch (contactHistoryType) {
    case ContactHistoryType.email:
      return "Email";
    case ContactHistoryType.mobilepush:
      return "Push notification (mobile)";
    case ContactHistoryType.scenarioupdate:
      return "Mise à jour du scénario";
    case ContactHistoryType.calltranscript:
      return "Transcription d'appel téléphonique";
    case ContactHistoryType.updatemanualinfo:
      return "Mise à jour manuelle des informations de la fiche";
    case ContactHistoryType.qualification:
      return "Qualification du prospect par l'IA";
    case ContactHistoryType.messagereceived:
      return "Message reçu";
    case ContactHistoryType.messagesent:
      return "Message envoyé";
    case ContactHistoryType.datadeletionrequest:
      return "Demande de suppression de données";
    case ContactHistoryType.contactexist:
      return "Contact déjà existant";
    case ContactHistoryType.phoneexist:
      return "Numéro de téléphone déjà existant";
    case ContactHistoryType.updatebyiainfo:
      return "Mise à jour des informations de la fiche par l'IA";
    case ContactHistoryType.aipaused:
      return "Mise en pause de l'IA";
    case ContactHistoryType.taskcreated:
      return "Tâche créée";
    case ContactHistoryType.taskupdated:
      return "Tâche mise à jour";
    case ContactHistoryType.updatedbyleedflow:
      return "Mise à jour des informations de la fiche par texte ou vocale";
    case ContactHistoryType.note:
      return "Note créée";
    case ContactHistoryType.call:
      return "Appel";
    case ContactHistoryType.receptionist:
      return "Réceptionniste IA a répondu";
    case ContactHistoryType.voicemailreceived:
      return "Message vocal reçu";
    case ContactHistoryType.notificationupdate:
      return "Mise à jour de la notification de relance";
    case ContactHistoryType.whatsappsent:
      return "Message WhatsApp envoyé";
    case ContactHistoryType.whatsappreceived:
      return "Message WhatsApp reçu";
    case ContactHistoryType.whatsappsummary:
      return "Conversation WhatsApp";
    case ContactHistoryType.tagsupdatedbyia:
      return "Tags mis à jour par l'IA";
    case ContactHistoryType.confidentialenabled:
      return "Mode confidentiel activé";
    case ContactHistoryType.confidentialdisabled:
      return "Mode confidentiel désactivé";
    default:
      return "";
  }
};

// Get the history type icon
export const contactHistoryTypeAsIcon = (contactHistoryType: ContactHistoryType): string => {
  switch (contactHistoryType) {
    case ContactHistoryType.email:
      return "✉️";
    case ContactHistoryType.mobilepush:
    case ContactHistoryType.whatsappsummary:
      return "📱";
    case ContactHistoryType.scenarioupdate:
      return "🔃";
    case ContactHistoryType.calltranscript:
      return "📞";
    case ContactHistoryType.updatemanualinfo:
      return "🗒️";
    case ContactHistoryType.qualification:
      return "🤖";
    case ContactHistoryType.messagereceived:
    case ContactHistoryType.whatsappreceived:
      return "📥";
    case ContactHistoryType.messagesent:
    case ContactHistoryType.whatsappsent:
      return "📤";
    case ContactHistoryType.datadeletionrequest:
      return "🚨";
    case ContactHistoryType.contactexist:
      return "❌";
    case ContactHistoryType.phoneexist:
      return "📑";
    case ContactHistoryType.updatebyiainfo:
      return "🤖";
    case ContactHistoryType.call:
      return '📞';
    case ContactHistoryType.receptionist:
      return '🔔';
    case ContactHistoryType.voicemailreceived:
      return '🎙️';
    case ContactHistoryType.notificationupdate:
      return "🔔";
    case ContactHistoryType.tagsupdatedbyia:
      return "🏷️";
    case ContactHistoryType.confidentialenabled:
      return "🔒";
    case ContactHistoryType.confidentialdisabled:
      return "🔓";
    default:
      return "";
  }
};